import Seo from "@/components/Seo";

export default function MentionsLegales() {
  return (
    <div className="max-w-[820px] mx-auto px-5 md:px-10 py-16 md:py-24" data-testid="mentions-legales-page">
      <Seo
        title="Mentions légales"
        description="Mentions légales du site Luigi Chauveau, menuisier agenceur."
        path="/mentions-legales"
      />
      <p className="text-eyebrow mb-6">05 — Mentions légales</p>
      <h1 className="h-display text-4xl md:text-6xl mb-12 leading-tight">Mentions légales.</h1>

      <Section title="Éditeur du site">
        <p>
          Luigi Chauveau — entreprise individuelle.<br />
          SIRET : 810 689 638 00015<br />
          Téléphone : 07 61 05 10 61<br />
          Email : contact@luigichauveau.fr
        </p>
      </Section>

      <Section title="Directeur de la publication">
        <p>Luigi Chauveau.</p>
      </Section>

      <Section title="Hébergement">
        <p>
          Le site est hébergé sur l'infrastructure Emergent. Les coordonnées
          précises de l'hébergeur sont communiquées sur demande à l'éditeur.
        </p>
      </Section>

      <Section title="Propriété intellectuelle">
        <p>
          L'ensemble des contenus présents sur ce site (textes, photographies,
          réalisations, design) sont la propriété de Luigi Chauveau. Toute
          reproduction sans autorisation expresse est interdite.
        </p>
      </Section>

      <Section title="Données personnelles">
        <p>
          Les informations transmises via le formulaire de contact sont
          utilisées uniquement pour répondre à votre demande. Aucune
          réutilisation marketing, aucune cession à des tiers. Conservation
          limitée au temps nécessaire au traitement du dossier. Vous pouvez
          demander la suppression à tout moment en écrivant à
          contact@luigichauveau.fr.
        </p>
      </Section>

      <Section title="Assurances professionnelles">
        <p>
          Décennale et RC Pro à jour. Attestations transmises sur simple
          demande à contact@luigichauveau.fr.
        </p>
      </Section>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div className="mb-12">
      <h2 className="font-serif text-2xl md:text-3xl mb-4 leading-tight">{title}</h2>
      <div className="text-[15px] leading-[1.7] text-foreground/85 space-y-3">{children}</div>
    </div>
  );
}
